import * as React from 'react';
import {Container as ContainerUI} from "@mui/material";
import {useSelector} from "react-redux";
import {styled} from "@mui/material/styles";

const StyledContainer = styled(ContainerUI)(({ theme }) => ({
    display: "flex",
    flexDirection: "column",
    flexGrow: 1,
    [theme.breakpoints.up("xs")]: {
        padding: theme.spacing(4, 2),
    },
    [theme.breakpoints.up("sm")]: {
        padding: theme.spacing(4, 3),
    },
    [theme.breakpoints.up("md")]: {
        padding: theme.spacing(4, 3),
    },
    [theme.breakpoints.up("lg")]: {
        padding: theme.spacing(4, 3),
    },
    [theme.breakpoints.up("xl")]: {
        padding: theme.spacing(4, 3),
    },
}));

export const Container = ({ children, styles, maxWidth, minWidth, fullWidth }) => {
    const config = useSelector((store) => store.app);

    return (
        <StyledContainer
            component="main"
            sx={{
                zIndex: 9,
                mt: `${config.appBarHeight}px`,
                maxWidth: maxWidth || {
                    xs: fullWidth ? "100vw" : "100vw",
                    sm: fullWidth ? "100vw" : "90vw",
                    md: fullWidth ? "100vw" : "92vw",
                    lg: fullWidth ? "100vw" : "95vw",
                    xl: fullWidth ? "100vw" : "55vw",
                },
                minWidth: minWidth || {
                    xs: "320px",
                    sm: "540px",
                    md: "720px",
                    lg: "960px",
                    xl: "1320px",
                },
                m: `${config.appBarHeight}px auto 0`,
                p: 0,
                ...styles,
            }}
        >
            {children}
        </StyledContainer>
    );
};
